import { render, staticRenderFns } from "./CustomTextArea.vue?vue&type=template&id=368e3f6a&scoped=true&"
import script from "./CustomTextArea.vue?vue&type=script&lang=js&"
export * from "./CustomTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368e3f6a",
  null
  
)

export default component.exports